import { API_BASE_URL } from './request';

/**
 * Resolve avatar path from API to a full image URL.
 *
 * @param {string|null|undefined} avatarUrl stored avatar path or absolute URL
 * @param {string|number|null|undefined} cacheKey optional cache-bust query value
 * @returns {string|null}
 */
export function resolveAvatarUrl(avatarUrl, cacheKey) {
  if (!avatarUrl) return null;
  if (/^https?:\/\//i.test(avatarUrl)) {
    return cacheKey == null ? avatarUrl : `${avatarUrl}?v=${encodeURIComponent(cacheKey)}`;
  }
  const base = API_BASE_URL.replace(/\/$/, '');
  const path = avatarUrl.startsWith('/') ? avatarUrl : `/${avatarUrl}`;
  const url = `${base}${path}`;
  return cacheKey == null ? url : `${url}?v=${encodeURIComponent(cacheKey)}`;
}

/**
 * Format byte size for display.
 *
 * @param {number} bytes
 * @returns {string}
 */
export function formatBytes(bytes) {
  const value = Number(bytes);
  if (!Number.isFinite(value) || value < 0) return '0 B';
  if (value < 1024) return `${value} B`;
  if (value < 1024 * 1024) return `${(value / 1024).toFixed(1)} KB`;
  return `${(value / (1024 * 1024)).toFixed(1)} MB`;
}
